export const isStaEnv =
  process.env.APP_ENV !== 'prod' && process.env.APP_ENV !== 'uat';

export const isProdEnv = process.env.APP_ENV === 'prod';

export const isUatEnv = process.env.APP_ENV === 'uat';
